import { createFileRoute } from '@tanstack/react-router';
import RouteList from '~/containers/RouteList';

export const Route = createFileRoute('/trolley-routes/')({
  component: RouteList,
});
